import React, { useEffect, useState } from "react";
import { api } from "../../../app/Api/ApiSlice";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import moment from "moment";
import "../storesStyles.css";

// Page for showing all invoices a business has sent
const StoreInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { name } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getInvoices = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(
          `/stores/${name}/manage/invoices`
        );

        // console.log(response)

        setInvoices(response.data || []);
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to load invoices"
        );
      } finally {
        setIsLoading(false);
      }
    };

    getInvoices();
  }, [name]);

  return (
    <div className="store-orders-container">
      <h2 className="page-title">Invoices</h2>

      {isLoading && <Loader />}

      {!isLoading && invoices.length === 0 && (
        <p className="not-found-msg">
          {name} has not issued any invoices
        </p>
      )}

      {!isLoading && invoices.length > 0 && (
        <div className="table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Invoice No</th>
                <th>Order</th>
                <th>Customer</th>
                <th>Status</th>
                <th>Items</th>
                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              {invoices.map(invoice => (
                <tr
                  key={invoice._id}
                  onClick={() =>
                    navigate(
                      `/b/manage/${name}/invoices/${invoice._id}`,{state:{invoice}}
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    {moment(invoice.createdAt).format("DD MMM YYYY")}
                  </td>

                  <td>{invoice.invoiceNo}</td>

                  <td>{invoice.order}</td>

                  <td>
                    {invoice.customer?.firstname}{" "}
                    {invoice.customer?.lastname}
                  </td>

                  <td>
                    <span
                      className={`order-status ${
                        invoice.isPaid ? "Paid" : "Pending"
                      }`}
                    >
                      {invoice.isPaid ? "Paid" : "Due"}
                    </span>
                  </td>

                  <td>{invoice.items?.length || 0}</td>

                  <td className="order-total">
                    ${invoice.total}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default StoreInvoices;
